var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChainlink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 320 330",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "#fff",
    fillRule: "evenodd",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinejoin: "miter",
    fill: "none"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#B",
    strokeWidth: 24,
    stroke: "#efb0ff"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#B",
    strokeWidth: 10,
    stroke: "#a440f2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "B",
    d: "M158.4 12l-30.98414 15.75183-84.43172 43.14633L12 86.65001v149.29998l30.98414 15.75185 85.20637 43.14636L159.17465 310.6l30.98413-15.7518 83.65708-43.14636 30.98413-15.75185V86.65001l-30.98413-15.75185-84.43173-43.14633zM73.96827 204.44633v-86.29266L158.4 75.00735l84.43172 43.14632v86.29266L158.4 247.59268z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChainlink);
export default __webpack_public_path__ + "static/media/chainlink.dcddfdd2bc9b9392a3e9eecde1d17173.svg";
export { ForwardRef as ReactComponent };